export default function loggedInUserEndpointConverter({ data, included }) {
  // Handle direct user response (e.g., from PATCH /v6/users/:id)
  if (data && data.type === 'users') {
    return {
      id: data.id,
      name: data.attributes.name,
      email: data.attributes.email,
    }
  }

  // Handle ping response with included users (e.g., from GET /v6/ping?include=user)
  // There is only one user included
  const user = included
    .filter((x) => x.type === 'users')
    .map((u) => ({
      id: u.id,
      name: u.attributes.name,
      email: u.attributes.email,
    }))[0]

  return user
}
